<template>
  <div class="reply-content">
    <div class="reply-item" v-for="(item, index) in replyList" :key="index">
      <div class="reply-time">
        <span><span style="margin-right: 10px;">交货日期</span>(回复时间：<span v-format="'yyyy-MM-dd'">{{item.createTime}}</span>)</span>
        <span>数量</span>
      </div>
      <div class="reply-text" v-for="(sitem, sindex) in item.splitList" :key="sindex">
        <span v-format="'yyyy-MM-dd'">{{sitem.delivery}}</span>
        <span>{{sitem.qty}}</span>
      </div>
      <div class="reply-circle"></div>
      <div class="reply-line"></div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    replyList: Array
  }
};
</script>

<style>
.reply-content {
  padding: 10px 16px;
  font-size: .9em;
  line-height: 2;
}
.reply-item {
  position: relative;
  padding-left: 20px;
  padding-bottom: 20px;
}
.reply-time {
  display: flex;
  justify-content: space-between;
  color: var(--weui-FG-1);
}
.reply-text {
  display: flex;
  justify-content: space-between;
  color: var(--weui-FG-0);
}
.reply-circle{
  width: 14px;
  height: 14px;
  background: var(--weui-FG-2);
  border-radius: 50%;
  position: absolute;
  top: 6px;
  left: 0;
}
.reply-line{
  width: 1px;
  background: var(--weui-FG-2);
  position: absolute;
  top: 20px;
  left: 7px;
  bottom: -6px;
}
.reply-item:last-of-type .reply-line {
  display: none;
}
</style>